export default "__VITE_ASSET__p7HyMw54__"